import { render, staticRenderFns } from "./listar-avaliar-estabelecimento.vue?vue&type=template&id=63a7f76b&"
import script from "./listar-avaliar-estabelecimento.vue?vue&type=script&lang=ts&"
export * from "./listar-avaliar-estabelecimento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63a7f76b')) {
      api.createRecord('63a7f76b', component.options)
    } else {
      api.reload('63a7f76b', component.options)
    }
    module.hot.accept("./listar-avaliar-estabelecimento.vue?vue&type=template&id=63a7f76b&", function () {
      api.rerender('63a7f76b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/avaliar-estabelecimento/listar-avaliar-estabelecimento.vue"
export default component.exports